module.exports = __webpack_public_path__ + "img/11.82117e11.svg";